module.exports = __webpack_public_path__ + "static/media/favicon.d006437b.ico";